/* eslint-disable no-restricted-globals */
import { useMemo } from 'react';

import AccountService from '../../services/AccountService';
import useForm from '../utils/useForm';

const useLineItemForm = (onSubmit, values) => {
  const submitHandler = (formValues, actions) => {
    onSubmit(formValues);
    actions.resetForm();
  };

  const fields = useMemo(
    () => [
      {
        title: '',
        fields: [
          {
            title: 'Description',
            name: 'description',
            type: 'text',
            required: true,
          },
          {
            title: 'Amount',
            name: 'amount',
            type: 'currency',
            required: true,
          },
          {
            title: 'Account',
            name: 'account_id',
            type: 'fetchableSelect',
            fetchOptions: {
              key: ['accounts'],
              queryFn: AccountService.getAccounts,
              labelKey: 'name',
            },
            required: true,
          },
        ],
      },
    ],
    []
  );

  return useForm({ fields, onSubmit: submitHandler, values });
};

export default useLineItemForm;
